<template>
    <div class="uk-investor-statement">
        <h1 class="uk-investor-statement__title"> {{ $t('jurisdictionRequirements.domesticRinggitBorrowing.statementTitle') }}</h1>
        <div class="uk-investor-statement__container">
            <div class="options">
                <div v-for="(option,index) in options"
                    :key="index"
                    class="radio__wrapper"
                    @click="toggleOption(index)"
                >
                    <div class="radio">
                        <div
                            class="radio__circle"
                        />
                        <div v-if="option.checked"
                            class="radio__circle--fill"
                        />
                    </div>
                    <label class="radio__label"
                        :for="index"
                    >
                        <translation-string
                            class="uk-investor-statement__message"
                            :translation="option.text"
                        />
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Components
import translationString from '@webapp/components/translation-string.vue';

export default {
    name: 'uk-investor-statement',
    components: {
        translationString,
    },
    props: {
        requirement: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            options: [
                {
                    checked: false,
                    text: this.$t('jurisdictionRequirements.ukSelfCategorisation.investorType1'),
                    value: 'restricted-investor',
                },
                {
                    checked: false,
                    text: this.$t('jurisdictionRequirements.ukSelfCategorisation.investorType2'),
                    value: 'sophisticated-investor',
                },
                {
                    checked: false,
                    text: this.$t('jurisdictionRequirements.ukSelfCategorisation.investorType3'),
                    value: 'high-net-worth-investor',
                },
            ],
        };
    },
    computed: {
        selectedOptionIndex() {
            return this.options.findIndex((option) => option.checked);
        },

        userHasSelected() {
            return this.options.some((option) => option.checked);
        },
    },
    methods: {
        updateOptionsByIndex(index) {
            this.options.forEach((opt) => {
                opt.checked = false;
            });

            this.options[index].checked = true;

            this.handleStepConfirmation();
        },

        toggleOption(index) {
            this.updateOptionsByIndex(index);
        },

        handleStepConfirmation() {
            if (this.userHasSelected) {
                this.$emit('completed', {
                    investorType: this.options[this.selectedOptionIndex].value,
                });
            } else {
                this.$emit('in-progress');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.uk-investor-statement {
    &__container {
        max-width: 1024px;
        margin: 0 auto;
        padding: 16px 32px;
        color: $black-color;
        background-color: $white-color;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    &__title {
        font-size: 2.5rem;
        color: #002e3c;
        padding: 0 2rem;
        text-align: center;
    }

    .options {
        & .radio {
            position: relative;

            &__wrapper {
                display: flex;
                margin: 20px 0;
                cursor: pointer;
            }

            &__circle {
                height: 15px;
                width: 15px;
                margin-right: 10px;
                border: 1px solid $lima-color;
                border-radius: 50%;

                &--fill {
                    height: 11px;
                    width: 11px;
                    background-color: $lima-color;
                    border-radius: 50%;
                    position: absolute;
                    top: 3px;
                    left: 3px;
                }
            }

            &__label {
                font-size: 1.65rem;
                margin-top: -2px;
                cursor: pointer;
            }
        }
    }

    &__message {
        font-size: 1.65rem;
        line-height: 24px;
    }

    .checkbox {
        padding: 0;
        margin: 12px 0;
    }

    &__actions {
        display: flex;
        justify-content: flex-end;

        .btn {
            @include min-width(md) {
                width: 21.9rem;
            }

            &--disabled {
                opacity: 0.3;
            }
        }
    }
}
</style>